import React from 'react';
import PropTypes from 'prop-types';
import MaterialCheckbox from '@material-ui/core/Checkbox';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { getHelpOrError, hasError } from './_common';

const Checkbox = ({
  value,
  name,
  onChange,
  label,
  errors,
  ...rest
}) => {
  return (
    <>
      <FormGroup row>
        <FormControlLabel
          control={(
            <MaterialCheckbox
              checked={!!value}
              value={!!value}
              onChange={onChange}
              name={name}
              color="primary"
              {...rest}
            />
          )}
          label={label}
        />
      </FormGroup>
      <FormHelperText error={hasError(errors, name)}>
        <span>{getHelpOrError('', errors, name)}</span>
      </FormHelperText>
    </>
  );
};

Checkbox.propTypes = {
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({}),
  label: PropTypes.node,
};

export default Checkbox;
